// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Despesas_SalvarResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /despesas/salvar
 *
 * Returned on the success path of Despesas::salvar(). The `dados` field of
 * the envelope is the integer despesa_id (insertId for create, affected
 * row id for update) — preserved from the legacy primitive-dados shape via
 * a custom getDados() override.
 *
 * Failure paths use $this->sendError('...') in the controller; no
 * ResponseContract is needed for errors.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Despesas_SalvarResponseDados = number;

export type Despesas_SalvarResponse = ApiResponse<Despesas_SalvarResponseDados>;

registerResponseContract('Despesas_SalvarResponse', {})
